import {AnyAction} from 'redux';
import * as types from './types';

export const setReloadGroupTree = (payload: boolean): AnyAction => ({
  type: types.SET_RELOAD_GROUP_TREE,
  payload,
});
